import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, A11y } from 'swiper/modules';

import Section from '@common/Section';
import Container from '@common/Container';
import Row from '@common/Row';
import Heading from '@common/Heading';
import Button from '@common/Button';
import RichText from '@common/RichText';
import Quote from '@common/Quote';
import Circle from '@images/circle.svg';

const ReviewsSliderWithFilter = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  // Removed filter
  // const [filterBy, setFilterBy] = useState(null);
  // const [selectedOption, setSelectedOption] = useState(null);
  // const [filteredList, setFilteredList] = useState(list);
  // useEffect(() => {
  //   let newFilter = [];

  //   // Find available categories and add to the filter dropdown
  //   for (let i = 0; i < list?.length; i++) {
  //     const categories = list[i]?.category;
  //     for (let j = 0; j < categories?.length; j++) {
  //       if (newFilter.findIndex(x => x === categories[j]) === -1) {
  //         newFilter.push(categories[j]);
  //       }
  //     }
  //   }

  //   // Set new filter
  //   setFilterBy(newFilter);
  // },[list])
  // const handleChange = (value) => {
  //   // Deactivate if already active
  //   if (selectedOption === value) {
  //     setSelectedOption(null)
  //     setFilteredList(list);
  //     return;
  //   }

  //   // Sets value of the dropdown
  //   setSelectedOption(value);

  //   // Filter list based on category name. Used 'some' in case reviews have 2 categories
  //   const newList = list?.filter(review => review.category.some(name => name === value));

  //   // Set the new list value
  //   setFilteredList(newList);
  // }
  return (
    <Section spacing='mb-8' className={clsx('pb-8',{[`bg-${bgColour}`]: bgColour })}>
      <Container className='position-relative'>
        <Row style={{marginTop: -50, marginBottom: 50}}>
          {(showTitle && title) && <Heading type='h2' className='col-lg-7 mb-0'>{title}</Heading>}
          {/* {filterBy &&
            <div className='d-flex justify-content-center'>
              {filterBy.map((filter, index) => (
                <Button
                  key={index}
                  variant='outline-white'
                  size='sm'
                  addClass={clsx('m-2 fs-18', {'active':selectedOption === filter})}
                  copy={filter}
                  onClick={() => handleChange(filter)}
                />
              ))}
            </div>
          } */}
        </Row>
        {list &&
          <Row>
            <Swiper
              className='col-9 reviews-filter-swiper'
              modules={[Navigation, A11y]} 
              slidesPerView={1}
              spaceBetween={20}
              navigation={true}
              loop
              breakpoints={{
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 20
                }
              }}
              >
              {list.map((card, index) => (
                <SwiperSlide key={index} className='d-flex flex-column border border-black border-3 rounded bg-white p-4 align-items-center'>
                  {card.bgColour && <Quote colour={card.bgColour}/>}
                  {card.review && 
                    <div className='mt-3 flex-fill'>
                      <RichText json={card.review}/>
                    </div>
                  }
                  {(card.name || card.company) &&
                    <div className='align-self-start fs-20'>
                      {card.name && <p className='mb-0'>{card.name}</p>}
                      {card.company && <p>{card.company}</p>}
                    </div>
                  }
                  {card.bgColour &&
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      height: 16,
                      width: '100%'
                    }} className={clsx(`bg-${card.bgColour}`)}/>
                  }
                </SwiperSlide>
              ))}
            </Swiper>
          </Row>
        }
        <img src={Circle} alt='' height={397} width={397} style={{position: 'absolute', right: -200, bottom: -200}}/>
      </Container>
    </Section>
  )
}

export default ReviewsSliderWithFilter
